<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9.01748 1.66949L9.10081 1.68366L16.1841 3.35033
  C16.3071 3.37909 16.4184 3.4444 16.5035 3.53767
  C16.5886 3.63093 16.6434 3.74778 16.6608 3.87283L16.6666 3.95866V16.042
  C16.6667 16.1682 16.6285 16.2916 16.5571 16.3957
  C16.4857 16.4998 16.3844 16.5799 16.2666 16.6253L16.185 16.6503L9.10165 18.317
  C9.0169 18.337 8.92891 18.339 8.84333 18.323C8.75774 18.3069 8.67645 18.2732 8.60466 18.224
  C8.53288 18.1747 8.47217 18.111 8.42645 18.0369
  C8.38073 17.9628 8.35099 17.8799 8.33915 17.7937L8.33331 17.7087V2.29199
  C8.33321 2.13006 8.39596 1.9744 8.50835 1.85782
  C8.62073 1.74123 8.77398 1.67282 8.93581 1.66699L9.01748 1.66949
  ZM9.58331 3.08116V16.9195L15.4166 15.547V4.45366L9.58331 3.08116
  ZM7.49998 3.33366V4.58366H4.58331V15.417H7.49998V16.667H3.95831
  C3.80728 16.667 3.66136 16.6123 3.54754 16.513
  C3.43371 16.4138 3.35969 16.2766 3.33915 16.127L3.33331 16.042V3.95866
  C3.33332 3.80763 3.38802 3.66171 3.48729 3.54788
  C3.58656 3.43406 3.72368 3.36003 3.87331 3.33949L3.95831 3.33366H7.49998ZM11.6666 9.16699
  C11.8877 9.16699 12.0996 9.25479 12.2559 9.41107C12.4122 9.56735 12.5 9.77931 12.5 10.0003
  C12.5 10.2213 12.4122 10.4333 12.2559 10.5896C12.0996 10.7459 11.8877 10.8337 11.6666 10.8337
  C11.4456 10.8337 11.2337 10.7459 11.0774 10.5896C10.9211 10.4333 10.8333 10.2213 10.8333 10.0003
  C10.8333 9.77931 10.9211 9.56735 11.0774 9.41107C11.2337 9.25479 11.4456 9.16699 11.6666 9.16699Z"
    :fill="color ? color : theme === 'light' ? '#818181' : '#fff'"
    />
  </svg>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({ theme: 'getTheme' }),
  },
  data() {
    return {
      isHover: false,
    };
  },
  props: {
    color: {
      type: String,
    },
    width: {
      type: String,
      default: '20',
    },
    height: {
      type: String,
      default: '20',
    },
  },
};
</script>
